import React, { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import { videoUploadTabs } from "constants/eval_constants";
import { GoalLine, StoryLineImageContainer, StoryLineImage } from "../styles";
import { GET_STORY_LINE } from "./storyLine";
import CollapsibleContent from "../../../../../common/CollapsibleContent";
import RadioCollapsibleContent from "../../../../../common/RadioCollapsibleContent";
import {
  List,
  OptionText,
  OrderList,
  QuestionText,
  Segment,
  Title,
  TitleIndicate,
  UnOrderList,
  VideoListItem,
} from "components/User/Evaluation/styles";

interface Video2Props {
  language: string;
}

interface Video2State {}

type Props = Video2Props & RouteComponentProps & WithTranslation;

export function Video2Preload({ language }) {
  const {
    storyLine1png,
    storyLine2png,
    storyLine3png,
    storyLine4png,
    storyLine1webp,
    storyLine2webp,
    storyLine3webp,
    storyLine4webp,
  } = GET_STORY_LINE(language);
  return (
    <div style={{ display: "none" }}>
      <picture>
        <source srcSet={storyLine1webp} type="image/webp" />
        <StoryLineImage src={storyLine1png} alt="Storyline1" />
      </picture>
      <picture>
        <source srcSet={storyLine2webp} type="image/webp" />
        <StoryLineImage src={storyLine2png} alt="Storyline2" />
      </picture>
      <picture>
        <source srcSet={storyLine3webp} type="image/webp" />
        <StoryLineImage src={storyLine3png} alt="Storyline3" />
      </picture>
      <picture>
        <source srcSet={storyLine4webp} type="image/webp" />
        <StoryLineImage src={storyLine4png} alt="Storyline4" />
      </picture>
    </div>
  );
}

class Video2 extends Component<Props, Video2State> {
  goal = () => {
    const { t } = this.props;
    const goal1 = t("user.survey.corePro.video.video2.goal1");
    const goal2 = t("user.survey.corePro.video.video2.goal2");
    const goal2Bold = t("user.survey.corePro.video.video2.goal2Bold");
    
    return (
      <Segment>
        <QuestionText>
          {t("user.survey.corePro.video.videoRecording.goal")}
        </QuestionText>
        <GoalLine />
        <OptionText style={{ whiteSpace: 'pre-line' }}>
          {goal1}
          {goal2Bold && goal2Bold.trim() !== "" && (
            <div style={{ marginTop: '12px' }}>{goal2Bold}</div>
          )}
        </OptionText>
      </Segment>
    );
  };

  role = () => {
    const { t } = this.props;
    const role = t("user.survey.corePro.video.video2.role");
    
    if (!role || role.trim() === "") {
      return null;
    }
    
    return (
      <Segment>
        <QuestionText>
          {t("user.survey.corePro.video.videoRecording.yourRole")}
        </QuestionText>
        <GoalLine />
        <OptionText>{role}</OptionText>
      </Segment>
    );
  };

  instructions = () => {
    const { t } = this.props;
    const instructions1 = t("user.survey.corePro.video.video2.instructions1");
    const instructions2 = t("user.survey.corePro.video.video2.instructions2");
    const instructions3 = t("user.survey.corePro.video.video2.instructions3");
    
    const hasContent = (instructions1 && instructions1.trim() !== "") ||
                       (instructions2 && instructions2.trim() !== "") ||
                       (instructions3 && instructions3.trim() !== "");
    
    if (!hasContent) {
      return null;
    }
    
    return (
      <Segment>
        <QuestionText>
          {t("user.survey.corePro.video.videoRecording.instructions")}
        </QuestionText>
        <GoalLine />
        <OrderList>
          {instructions1 && instructions1.trim() !== "" && (
            <VideoListItem>
              <OptionText style={{ whiteSpace: 'pre-line' }}>
                {instructions1}
              </OptionText>
            </VideoListItem>
          )}
          {instructions2 && instructions2.trim() !== "" && (
            <VideoListItem>
              <OptionText style={{ whiteSpace: 'pre-line' }}>
                {instructions2}
              </OptionText>
            </VideoListItem>
          )}
          {instructions3 && instructions3.trim() !== "" && (
            <VideoListItem>
              <OptionText style={{ whiteSpace: 'pre-line' }}>
                {instructions3}
              </OptionText>
            </VideoListItem>
          )}
        </OrderList>
      </Segment>
    );
  };

  storyLinePicture = () => {
    const { language } = this.props;
    const {
      storyLine1png,
      storyLine2png,
      storyLine3png,
      storyLine4png,
      storyLine1webp,
      storyLine2webp,
      storyLine3webp,
      storyLine4webp,
    } = GET_STORY_LINE(language);
    return (
      <StoryLineImageContainer>
        <picture>
          <source srcSet={storyLine1webp} type="image/webp" />
          <StoryLineImage src={storyLine1png} alt="Storyline1" />
        </picture>
        <picture>
          <source srcSet={storyLine2webp} type="image/webp" />
          <StoryLineImage src={storyLine2png} alt="Storyline2" />
        </picture>
        <picture>
          <source srcSet={storyLine3webp} type="image/webp" />
          <StoryLineImage src={storyLine3png} alt="Storyline3" />
        </picture>
        <picture>
          <source srcSet={storyLine4webp} type="image/webp" />
          <StoryLineImage src={storyLine4png} alt="Storyline4" />
        </picture>
      </StoryLineImageContainer>
    );
  };

  sampleScenario = () => {
    const { t } = this.props;
    return (
      <CollapsibleContent
        header={
          <QuestionText>
            {t("user.survey.corePro.video.video2.sampleScenario")}
          </QuestionText>
        }
        content={
          <>
            <GoalLine />
            {this.storyLinePicture()}
          </>
        }
        defaultOpen={true}
      />
    );
  };

  //Not used
  simpleActivities = () => {
    const { t } = this.props;
    return (
      <CollapsibleContent
        header={
          <QuestionText>
            {t("user.survey.corePro.video.video2.simpleActivities")}
          </QuestionText>
        }
        content={
          <>
            <GoalLine />

            <OptionText style={{ marginTop: "16px" }}>
              <b>{t("user.survey.corePro.video.video2.simpleActivities1")}</b>
            </OptionText>
            <UnOrderList>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.simpleActivities2")}
                </OptionText>
              </List>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.simpleActivities3")}
                </OptionText>
              </List>
            </UnOrderList>
            <OptionText>
              <b>{t("user.survey.corePro.video.video2.simpleActivities4")}</b>
            </OptionText>
            <OrderList>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.simpleActivities5")}
                </OptionText>
              </List>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.simpleActivities6")}
                </OptionText>
              </List>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.simpleActivities7")}
                </OptionText>
              </List>
            </OrderList>
          </>
        }
      />
    );
  };

  //Not used
  advancedActivities = () => {
    const { t } = this.props;
    return (
      <CollapsibleContent
        header={
          <QuestionText>
            {t("user.survey.corePro.video.video2.advanced")}
          </QuestionText>
        }
        content={
          <>
            <GoalLine />
            <OptionText style={{ marginTop: "16px" }}>
              <b>{t("user.survey.corePro.video.video2.simpleActivities1")}</b>
            </OptionText>
            <UnOrderList>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.simpleActivities2")}
                </OptionText>
              </List>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.simpleActivities3")}
                </OptionText>
              </List>
            </UnOrderList>
            <OptionText>
              <b>{t("user.survey.corePro.video.video2.advanced4")}</b>
            </OptionText>
            <OrderList>
              <List>
                <OptionText>
                  {t("user.survey.corePro.video.video2.advanced5")}
                  {t("user.survey.corePro.video.video2.advanced6")}
                </OptionText>
              </List>
            </OrderList>
            <OptionText>
              <b>{t("user.survey.corePro.video.video2.advanced7")}</b>
            </OptionText>
            <OrderList>
              <List>
                {" "}
                <OptionText>
                  {t("user.survey.corePro.video.video2.advanced8")}
                  {t("user.survey.corePro.video.video2.advanced9")}
                </OptionText>
              </List>
              <List>
                {" "}
                <OptionText>
                  {t("user.survey.corePro.video.video2.advanced10")}
                </OptionText>
              </List>
              <List>
                {" "}
                <OptionText>
                  {t("user.survey.corePro.video.video2.advanced11")}
                </OptionText>
              </List>
            </OrderList>
          </>
        }
      />
    );
  };

  renderAdvancedContent = () => {
    const { t } = this.props;
    const advanced1 = t("user.survey.corePro.video.video2.advanced1");
    const advanced2 = t("user.survey.corePro.video.video2.advanced2");
    const advanced3 = t("user.survey.corePro.video.video2.advanced3");
    const advanced4 = t("user.survey.corePro.video.video2.advanced4");
    const advanced5 = t("user.survey.corePro.video.video2.advanced5");
    const advanced6 = t("user.survey.corePro.video.video2.advanced6");
    const advanced7 = t("user.survey.corePro.video.video2.advanced7");
    const advanced8 = t("user.survey.corePro.video.video2.advanced8");
    const advanced9 = t("user.survey.corePro.video.video2.advanced9");
    const advanced10 = t("user.survey.corePro.video.video2.advanced10");
    
    return (
      <>
        {(advanced1 || advanced2 || advanced3) && (
          <>
            {advanced1 && advanced1.trim() !== "" && (
              <OptionText style={{ marginTop: "16px", whiteSpace: 'pre-line' }}>
                {advanced1}
              </OptionText>
            )}
            {advanced2 && advanced2.trim() !== "" && (
              <OptionText style={{ whiteSpace: 'pre-line' }}>
                {advanced2}
              </OptionText>
            )}
            {advanced3 && advanced3.trim() !== "" && (
              <OptionText style={{ whiteSpace: 'pre-line' }}>
                {advanced3}
              </OptionText>
            )}
          </>
        )}
        
        {advanced4 && advanced4.trim() !== "" && (
          <OptionText style={{ marginTop: "16px" }}>
            <b>{advanced4}</b>
          </OptionText>
        )}
        
        {(advanced5 || advanced6) && (
          <OrderList>
            {advanced5 && advanced5.trim() !== "" && (
              <List>
                <OptionText style={{ whiteSpace: 'pre-line' }}>
                  {advanced5}
                </OptionText>
              </List>
            )}
            {advanced6 && advanced6.trim() !== "" && (
              <List>
                <OptionText style={{ whiteSpace: 'pre-line' }}>
                  {advanced6}
                </OptionText>
              </List>
            )}
          </OrderList>
        )}
        
        {advanced7 && advanced7.trim() !== "" && (
          <OptionText style={{ marginTop: "16px" }}>
            <b>{advanced7}</b>
          </OptionText>
        )}
        
        {(advanced8 || advanced9 || advanced10) && (
          <OrderList>
            {advanced8 && advanced8.trim() !== "" && (
              <List>
                <OptionText style={{ whiteSpace: 'pre-line' }}>
                  {advanced8}
                </OptionText>
              </List>
            )}
            {advanced9 && advanced9.trim() !== "" && (
              <List>
                <OptionText style={{ whiteSpace: 'pre-line' }}>
                  {advanced9}
                </OptionText>
              </List>
            )}
            {advanced10 && advanced10.trim() !== "" && (
              <List>
                <OptionText style={{ whiteSpace: 'pre-line' }}>
                  {advanced10}
                </OptionText>
              </List>
            )}
          </OrderList>
        )}
      </>
    );
  };

  //Only one can open at a time
  simpleAndAdvancedActivities = () => {
    const { t } = this.props;
    return (
      <RadioCollapsibleContent
        header1={
          <QuestionText>
            {t("user.survey.corePro.video.video2.simpleActivities")}
          </QuestionText>
        }
        content1={
          <>
            <GoalLine />
            {(() => {
              const simpleActivities1 = t("user.survey.corePro.video.video2.simpleActivities1");
              const simpleActivities2 = t("user.survey.corePro.video.video2.simpleActivities2");
              const simpleActivities3 = t("user.survey.corePro.video.video2.simpleActivities3");
              const simpleActivities4 = t("user.survey.corePro.video.video2.simpleActivities4");
              const simpleActivities5 = t("user.survey.corePro.video.video2.simpleActivities5");
              const simpleActivities6 = t("user.survey.corePro.video.video2.simpleActivities6");
              const simpleActivities7 = t("user.survey.corePro.video.video2.simpleActivities7");
              
              return (
                <>
                  {simpleActivities1 && simpleActivities1.trim() !== "" && (
                    <OptionText style={{ marginTop: "16px", whiteSpace: 'pre-line' }}>
                      {simpleActivities1}
                    </OptionText>
                  )}
                  {(simpleActivities2 || simpleActivities3) && (
                    <UnOrderList>
                      {simpleActivities2 && simpleActivities2.trim() !== "" && (
                        <List>
                          <OptionText style={{ whiteSpace: 'pre-line' }}>
                            {simpleActivities2}
                          </OptionText>
                        </List>
                      )}
                      {simpleActivities3 && simpleActivities3.trim() !== "" && (
                        <List>
                          <OptionText style={{ whiteSpace: 'pre-line' }}>
                            {simpleActivities3}
                          </OptionText>
                        </List>
                      )}
                    </UnOrderList>
                  )}
                  {simpleActivities4 && simpleActivities4.trim() !== "" && (
                    <OptionText style={{ marginTop: "16px" }}>
                      <b>{simpleActivities4}</b>
                    </OptionText>
                  )}
                  {(simpleActivities5 || simpleActivities6 || simpleActivities7) && (
                    <OrderList>
                      {simpleActivities5 && simpleActivities5.trim() !== "" && (
                        <List>
                          <OptionText style={{ whiteSpace: 'pre-line' }}>
                            {simpleActivities5}
                          </OptionText>
                        </List>
                      )}
                      {simpleActivities6 && simpleActivities6.trim() !== "" && (
                        <List>
                          <OptionText style={{ whiteSpace: 'pre-line' }}>
                            {simpleActivities6}
                          </OptionText>
                        </List>
                      )}
                      {simpleActivities7 && simpleActivities7.trim() !== "" && (
                        <List>
                          <OptionText style={{ whiteSpace: 'pre-line' }}>
                            {simpleActivities7}
                          </OptionText>
                        </List>
                      )}
                    </OrderList>
                  )}
                </>
              );
            })()}
          </>
        }
        //Advanced Activity
        header2={
          <QuestionText>
            {t("user.survey.corePro.video.video2.advanced")}
          </QuestionText>
        }
        content2={
          <>
            <GoalLine />
            {this.renderAdvancedContent()}
          </>
        }
      ></RadioCollapsibleContent>
    );
  };

  notCooperative = () => {
    const { t } = this.props;
    const notCooperative1 = t("user.survey.corePro.video.video2.notCooperative1");
    const notCooperative2 = t("user.survey.corePro.video.video2.notCooperative2");
    const notCooperative3 = t("user.survey.corePro.video.video2.notCooperative3");
    const notCooperative4 = t("user.survey.corePro.video.video2.notCooperative4");
    
    const hasContent = (notCooperative1 && notCooperative1.trim() !== "") ||
                       (notCooperative2 && notCooperative2.trim() !== "") ||
                       (notCooperative3 && notCooperative3.trim() !== "") ||
                       (notCooperative4 && notCooperative4.trim() !== "");
    
    if (!hasContent) {
      return null;
    }
    
    return (
      <CollapsibleContent
        header={
          <QuestionText>
            {t("user.survey.corePro.video.video2.notCooperative")}
          </QuestionText>
        }
        content={
          <>
            <GoalLine />
            <UnOrderList>
              {notCooperative1 && notCooperative1.trim() !== "" && (
                <List>
                  <OptionText style={{ whiteSpace: 'pre-line' }}>
                    {notCooperative1}
                  </OptionText>
                </List>
              )}
              {notCooperative2 && notCooperative2.trim() !== "" && (
                <List>
                  <OptionText style={{ whiteSpace: 'pre-line' }}>
                    {notCooperative2}
                  </OptionText>
                </List>
              )}
              {notCooperative3 && notCooperative3.trim() !== "" && (
                <List>
                  <OptionText style={{ whiteSpace: 'pre-line' }}>
                    {notCooperative3}
                  </OptionText>
                </List>
              )}
              {notCooperative4 && notCooperative4.trim() !== "" && (
                <List>
                  <OptionText style={{ whiteSpace: 'pre-line' }}>
                    {notCooperative4}
                  </OptionText>
                </List>
              )}
            </UnOrderList>
          </>
        }
      />
    );
  };

  render() {
    return (
      <>
        {this.goal()}
        {this.role()}
        {this.instructions()}
        {this.simpleAndAdvancedActivities()}
        {this.notCooperative()}
        {this.sampleScenario()}
      </>
    );
  }
}

export default withRouter(withTranslation()(Video2));
